window.addEventListener('load', () => {
    const revealButton  = document.querySelector('[data-reveal-form]');
    const formStart     = document.getElementById('formStart');
    const formContainer = document.getElementById('formContainer');

    // This selector picks up whichever form exists on the page
    const formSection   = document.querySelector('#JoinCrewForm, #FindCrewForm');

    if (revealButton && formStart && formContainer && formSection) {
        revealButton.addEventListener('click', () => {
            // Hide the intro block and show the form
            formStart.dataset.active     = 'false';
            formContainer.dataset.active = 'true';

            // Smooth‑scroll to the form if ScrollSmoother is available
            if (window.smoother) {
                window.smoother.scrollTo(formSection, {
                    duration: 1.2,
                    ease: 'expo.out'
                });
            } else {
                // Fallback to native smooth scrolling for touch devices
                formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    }
});